import { getElement, ifSelectorExist } from './utils';

export const locationsSwitcher = () => {
  const locationsSelect = getElement('.locations-switcher-select');
  const locationsList = getElement('.locations-switcher-list');

  if (ifSelectorExist(locationsSelect) && ifSelectorExist(locationsList)) {
    locationsSelect.addEventListener('click', function () {
      const isActive = locationsList.style.display === 'flex';
      locationsList.style.display = isActive ? 'none' : 'flex';
      locationsSelect.classList.toggle('active');
    });
  }
}